<template>
  <div class="call-action flex grow cursor-pointer flex-col items-center gap-1">
    <div class="hover:opacity-90 [&>*]:h-10 [&>*]:w-10">
      <slot name="icon" />
    </div>
    <div class="text-center">
      <slot name="label" />
    </div>
  </div>
</template>
